/**
 * Main.js
 *
 * @since 1.0.0
 */
import 'whatwg-fetch'
import Raven from 'raven-js'
import LazyLoadFonts from './modules/LazyLoadFonts'
import ToolTip from './modules/ToolTip'
import YoutubeVideos from './modules/YoutubeVideos'
import Graphs from './modules/Graphs'
import ToggleMainNav from './modules/ToggleMainNav'
import Share from './modules/Share'
import SmoothScroll from './modules/SmoothScroll';
(function IIFE () {
  if (process.env.NODE_ENV === 'production') {
    Raven
      .config('https://127d5e40ea3d49b9b69659be2d60d066@sentry.io/147406')
      .install()
  }
  LazyLoadFonts()
  ToolTip()
  YoutubeVideos()
  ToggleMainNav()
  Graphs()
  Share()
  SmoothScroll()
})()



// WEBPACK FOOTER //
// ./src/js/main.js